import React from 'react';

import { ComponentIconProps } from '../types';

const NotificationSuccessIcon: React.FC<ComponentIconProps> = ({
  size = 24,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM10.64 14.38L16.29 8.73L17 9.43L10.64 15.8L7.43 12.6L8.14 11.89L10.64 14.38Z" />
  </svg>
);

export default NotificationSuccessIcon;
